var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeah = function SvgYeah(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5FA378",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m19.992 3.5-1.866.625a2.416 2.416 0 0 0-1.632 2.6 1.217 1.217 0 0 1-1.208 1.358h-.316c-.717 0-1.333.5-1.466 1.2l-.175.884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040512",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6 5h.008m13.984 3.5H20m-5.838-5h.008M19 17h.008"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5FA378",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m20.327 12.167-.683-.275a1.222 1.222 0 0 0-1.649.925 1.21 1.21 0 0 1-1.19 1.016h-.642"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040512",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.617 8.5 2 21.5l13-4.605"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#040512",
    strokeWidth: 1.5,
    d: "m5 12 6 6.5M4 16.5l3 3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5FA378",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m11.166 3 .275.683a1.223 1.223 0 0 1-.925 1.65c-.583.084-1.016.6-1.016 1.192v.642"
  })));
};
export default SvgYeah;